import { createSelector } from "reselect";
import { IStoreState } from "../../interfaces/IState";

export const getBookings = (state: IStoreState) => state.bookings;

export const getBookingStatus = createSelector(getBookings, booking => booking.status);
